import { environment } from '../../../environment';
import { getRequest } from '../../../Utils/api';

const url = {
  profile: `${environment['endpoint.minecraftServices']}minecraft/profile`
};

export function getProfileAPI() {
  return getRequest({ url: url.profile, serviceName: 'GetMinecraftJavaProfile' });
}
